import { render, staticRenderFns } from "./CartPaymentMethod.vue?vue&type=template&id=653536d1&"
import script from "./CartPaymentMethod.vue?vue&type=script&lang=ts&"
export * from "./CartPaymentMethod.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports